import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    course: '',
  },
}

export const courseComponentsUI = createSlice({
  name: 'courseComponentsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setCourse: (state, { payload }) => {
      state.tableFilters.course = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setCourse,
  trackActiveFilters,
  clearAllFilters,
} = courseComponentsUI.actions

export default courseComponentsUI.reducer
